import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { PROCESS_NAMES } from '../../../process/util/names'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = (state) => {
    return selectOwnState(state).fetching
}

export const selectEmailTemplateList = (state) => {
    return selectOwnState(state).emailTemplateList
}


export const selectUserSelection = (state) => {
    return selectOwnState(state).userSelection
}

export const selectUserSelectionProcess = state => {
    const userSelection = selectUserSelection(state)
    return userSelection.processName
}

export const selectUserSelectionLocale = state => {
    const userSelection = selectUserSelection(state)
    return userSelection.locale
}

export const selectProcessMacroList = (state) => {
    return selectOwnState(state).processMacroList
}

export const selectProcessMacroListForCurrentProcess = (state) => {
    const processMacroList = selectProcessMacroList(state)
    const processName = selectUserSelectionProcess(state)

    if (!processMacroList || !processName) {
        return null
    }
    return processMacroList[processName]
}


export const selectProcessList = (state) => {
    const templateList = selectEmailTemplateList(state)
    if (!templateList) {
        return []
    }
    const processList = {}
    templateList.map(({ processName }) => {
        processList[processName] = {
            id: processName,
            value: PROCESS_NAMES[processName],
        }
        return null
    })
    return Object.values(processList)
}


export const selectTemplateListForProcess = state => {
    const selectedProcessName = selectUserSelectionProcess(state)
    if (!selectedProcessName) {
        return []
    }
    let templateList = selectEmailTemplateList(state)

    templateList = templateList.filter(({ processName }) => {
        return processName === selectedProcessName
    })

    templateList.sort((a, b) => {
        if (a.technicalName < b.technicalName) { return -1 }
        if (a.technicalName > b.technicalName) { return 1 }
        return 0
    })

    return templateList
}

export const selectEmailTemplate = state => {
    return selectOwnState(state).emailTemplate
}


export const selectEmailTemplateVariantList = (state) => {
    const emailTemplate = selectEmailTemplate(state)
    if (!emailTemplate) {
        return []
    }
    const locale = selectUserSelectionLocale(state)

    return emailTemplate.templateVariantList.filter(emailTemplateVariant => {
        return emailTemplateVariant.locale === locale
    })
}

export const selectEmailTemplateVariantByLocalId = (state, localId) => {
    const emailTemplate = selectEmailTemplate(state)
    if (!emailTemplate) {
        return null
    }
    const variantList = emailTemplate.templateVariantList
    for (let index = 0; index < variantList.length; index++) {
        const variant = variantList[index]
        if (variant.localId === localId) {
            return variant
        }
    }
    return null
}

export const selectEmailTemplateVariantIdByLocalId = (state, localId) => {
    const emailTemplateVariant = selectEmailTemplateVariantByLocalId(state, localId)
    return emailTemplateVariant ? emailTemplateVariant.id : null
}




// WEBPACK FOOTER //
// ./src/modules/email/state/manage/selector.js